import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { ImageAddressProps } from '../../types';
import { popupStyles } from '../styles/popupStyles';

const styles = (theme: any) => ({
  row: popupStyles(theme).imageAddressRow,
  icon: popupStyles(theme).imageAddressIcon,
  address: popupStyles(theme).imageAddressText,
});

const ImageAddress: React.FC<ImageAddressProps & { classes: any }> = ({ address, classes }) => {
  return (
    <div className={classes.row}>
      <LocationOnOutlinedIcon className={classes.icon} />
      <span className={classes.address}>{address}</span>
    </div>
  );
};

export default withStyles(styles)(ImageAddress);
